import api from "axios";

export default function getFavorites() {
  return api
    .get("/evaluation/favorite")
    .then((response) => response.data.payload)
    .catch((error) => `getFavorites ${error}`);
}

export function getAutoBidsFavorite() {
  return api
    .get("/autoBid/favorite")
    .then((response) => response.data.payload)
    .catch((error) => `getAutoBidsFavorite ${error}`);
}

export function getDealersFavorite() {
  return api
    .get("/dealer/favorite")
    .then((response) => response.data.payload)
    .catch((error) => `getDealersFavorite ${error}`);
}
